import { KibButtonNew } from '@chewy/kib-controls-react';
import clsx from 'clsx';

import { useFreeTrialCtaLabel } from '@/hooks/useFreeTrialCtaLabel';

import styles from './SignUpButton.module.scss';

interface Props {
  handleAction: () => void;
  alignment?: 'left' | 'center' | 'right';
  loading?: boolean;
}

export const SignUpButton = ({ handleAction, alignment = 'center', loading }: Props) => {
  const freeTrialCtaLabel = useFreeTrialCtaLabel();
  return (
    <div className={clsx([styles.signupBtnContainer, styles[alignment]])}>
      <KibButtonNew data-testid="cms:sign-up-btn" loading={loading} onClick={handleAction}>
        {freeTrialCtaLabel}
      </KibButtonNew>
    </div>
  );
};
